import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { AppPermissions } from 'src/app/shared/app.permissions';
import { DateRangeFilterModel } from 'src/app/shared/models/date-range-filter-model';
import { GeographicFilterRegionModel } from 'src/app/shared/models/geographic-filter-region-model';
@Component({
  selector: 'ness-geographic-filter-region-status',
  templateUrl: './geographic-filter-region-status.component.html',
  styles: [':host-context(.d-flex.flex-wrap) { display: flex !important; flex-wrap: wrap !important;}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeographicFilterRegionStatusComponent  {

  dateRangeFilterModel$: Observable<DateRangeFilterModel> = this.filterService.dateRangeFilterModel;
  readonly canView = AppPermissions.canViewCrimeGunDetails;

   private _geographicFilterRegion: GeographicFilterRegionModel = null;
 @Input() set geographicFilterRegion(msg: GeographicFilterRegionModel) {
    this._geographicFilterRegion = msg;
  }

  get geographicFilterRegion(): GeographicFilterRegionModel {
    return this._geographicFilterRegion;
  }

  @Input() showFA: boolean = false;
  @Input() showEVID: boolean = false;
  @Input() showNIBINSite: boolean = false;
  @Input() showGeographic: boolean = false;
  @Input() hideAgencyTag: boolean = false;
  @Input() dateRangeFilterLabel: string = "";
  @Input() selectedNIBINSite: string = "All"

  constructor(private filterService: FilterService) { }
}
